/* RESPONSIBLE TEAM: team-knowledge-foundations */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
import { isArray } from '@ember/array';

const READ_ONLY_ATTRS = ['key', 'created_by_id', 'updated_by_id', 'created_at', 'updated_at'];

export default class DynamicContentSerializer extends EmbercomBaseSerializer {
  collectionKey: any = 'dynamic_contents';

  serialize(snapshot: any, options: any): any {
    let json = super.serialize(snapshot, options);
    for (let attr of READ_ONLY_ATTRS) {
      delete json[attr];
    }
    return json;
  }

  normalizeSingleResponse(
    store: any,
    primaryModelClass: any,
    payload: any,
    id: string | number,
    requestType: string,
  ): any {
    if (this.collectionKey && payload[this.collectionKey]) {
      let extracted = payload[this.collectionKey];
      payload = isArray(extracted) ? extracted[0] : extracted;
    } else if (payload.dynamic_content) {
      payload = payload.dynamic_content;
    }
    return super.normalizeSingleResponse(store, primaryModelClass, payload, id, requestType);
  }
}
